import { useTranslation } from "react-i18next";

import { Modal } from "../../../components/modal/Modal";
import { useAtiraFormContext } from "../context/form-context";

export const FormReadModal: React.FC = () => {
  const { t } = useTranslation();
  const {
    selectedForm: currentForm,
    formReadVisible,
    setFormReadVisible,
  } = useAtiraFormContext();

  const formLink = `${process.env.REACT_APP_API_URL}/form/${currentForm?._id}/generate`;

  if (!currentForm) {
    return null;
  }

  return (
    <Modal
      key={currentForm._id}
      open={formReadVisible}
      onClose={() => setFormReadVisible(false)}
      title={`${t("forms.read.modal.title")}: ${currentForm.title}`}
    >
      <iframe
        width="400px"
        height="600px"
        style={{ border: "none" }}
        src={formLink}
        title="preview form"
      />
    </Modal>
  );
};
